// Postprocessor registry.
//
// Add a new format → import + register here. The UI surfaces everything
// in `POSTPROCESSORS` automatically.

import csvCutList       from "./csv";
import dxfPanels        from "./dxf";
import woodwopMpr       from "./mpr";
import cabinetVisionCsv from "./cv_csv";

import type { Postprocessor } from "./types";

export const POSTPROCESSORS: Postprocessor[] = [
  csvCutList,
  dxfPanels,
  woodwopMpr,
  cabinetVisionCsv,
];

export function getPostprocessor(id: string): Postprocessor | null {
  return POSTPROCESSORS.find((p) => p.id === id) ?? null;
}

export type { Postprocessor, ExportContext, ExportArtifact, OptionValues } from "./types";
export { defaultOptions } from "./types";
